import { render, staticRenderFns } from "./ApproveFormOldInstanceIdPage.vue?vue&type=template&id=ed8344ee&scoped=true"
import script from "./ApproveFormOldInstanceIdPage.vue?vue&type=script&lang=js"
export * from "./ApproveFormOldInstanceIdPage.vue?vue&type=script&lang=js"
import style0 from "./ApproveFormOldInstanceIdPage.vue?vue&type=style&index=0&id=ed8344ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8344ee",
  null
  
)

export default component.exports